import { ConfigProvider, Form, Segmented, Switch } from "antd";
import { useTranslation } from "react-i18next";

const FormSwitch = ({
    label = "",
    name = "",
    placeholder = "",
    type = "text",
    size = "middle",
    onChange = () => { },
    className = "",
    subclassName = "",
    required = false,
    options = [],
    vertical = true,
    labelFontSize = "16px",
    fontWeight = "",
    bgColor = "#8A6FB9",
    textColor = "white",
    disabled = false,
    rules = null,
    dependencies = undefined
}) => {

    const handleChange = (e) => {
        const value = e;
        onChange(value);
    };

    const { t, i18n } = useTranslation();

    const layout = {
        labelCol: {
            span: 24
        },
        wrapperCol: {
            span: 24
        }
    }

    return (
        <ConfigProvider theme={{
            components: {
                Form: {
                    labelFontSize: labelFontSize
                },
                Segmented: {
                    itemSelectedBg: bgColor,
                    itemSelectedColor: textColor
                }
            }
        }}>
            <Form.Item
                {...(vertical && layout)}
                label={label}
                name={name}
                required={required}
                dependencies={dependencies}
                style={{
                    fontWeight: fontWeight,
                    padding: "0px",
                    margin: "0px"
                }}
                rules={rules ? [...rules, { required: required, message: i18n.language == 'th' ? 'กรุณาเปิดใช้งาน ${label}' : '${label} is required' }] : [{ required: required, message: i18n.language == 'th' ? 'กรุณาเปิดใช้งาน ${label}' : '${label} is required' }]}
            >
                <Switch
                    disabled={disabled}
                    required
                    name={name}
                    label={label}
                    size={size}
                    options={options}
                    onChange={handleChange}
                />
            </Form.Item>
        </ConfigProvider>
    )

}

export default FormSwitch;